var $e49254d6635b1a35$exports = {};
$e49254d6635b1a35$exports = {
    "loading": `Indl\xe6ser...`,
    "loadingMore": `Indl\xe6ser flere...`
};


export {$e49254d6635b1a35$exports as default};
//# sourceMappingURL=da-DK.module.js.map
